export default "__VITE_ASSET__UyKxgZC5__"